export default __webpack_public_path__ + "static/media/I0004.452244bd.png";